import Vue from "vue";

export const Input = {
  bind(el: HTMLElement, binding: any, vnode: any) {
    const inputEl = el as HTMLInputElement;
    if (inputEl.value) {
      el.classList.add("value");
    }

    el.addEventListener("focus", () => {
      el.classList.add("focused");
    });

    el.addEventListener("blur", () => {
      el.classList.remove("focused");
    });

    el.addEventListener("change", () => {
      testValue(el);
    });
  },
  update(el: HTMLElement, binding: any, vnode: any) {
    testValue(el);
  }
};

function testValue(el: HTMLElement) {
  const _el = el as HTMLInputElement;
  if (_el.value) {
    _el.classList.add("value");
  } else {
    _el.classList.remove("value");
  }
}

Vue.directive("mbe-input", Input);
